import React, { useEffect, useState } from 'react';

import { ArrowRightOutlined, MenuOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import { Anchor, Drawer, Button, Modal } from 'antd';
import emblemLogo from '../../assets/images/logo_emblem.svg';
import cdac_logo from '../../assets/images/svg_img/logo_cdac.svg';
import asaaua_logo from '../../assets/images/logo_asaaua.svg'
import '../common/Header.scss'
import ind_flag from '../Images/ind-flag.png';
import { Header } from 'antd/es/layout/layout';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Loginpage from '../Loginpage2';
import ForgetPassword from '../ForgetPassword';
// import GoogleTranslate from '../common/GoogleTranslate2';
// const { Link } = Anchor;

interface HeaderProps {
  active: string;
}

const AppHeader: React.FC<HeaderProps> = ({ active }) => {

  const [visible, setVisible] = useState(false);
  const [isFaqActive, setIsFaqActive] = useState(false);
  const [isHomeActive, setIsHomeActive] = useState(false);
  const [isAboutActive, setIsAboutActive] = useState(false);
  const [isServiceofferedActive, setIsServiceofferedActive] = useState(false);
  const [isRegistrationformActive, setRegistrationformActive] = useState(false);
  const [loginModel, setLoginmodel] = useState(false);
  const [forgetModal, setForgetModal] = useState(false);
  const [messege, setMessege] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsFaqActive(location.hash === '#faq');
    setIsAboutActive(location.hash === '#about');
    setIsServiceofferedActive(location.hash === '#serviceoffered');
    setIsHomeActive(location.hash === '#home');
    setRegistrationformActive(location.pathname === '/registrationform');
  }, []);
  // const [hovered, setHovered] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsFixed(scrollTop > 130); // adjust the threshold
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleFaqClick = (id_name: string) => {
    navigate(`/#${id_name}`); // navigate to homepage first

    // Scroll after short delay to ensure the page is rendered
    setTimeout(() => {
      const faqSection = document.getElementById(`${id_name}`);
      if (faqSection) {
        faqSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  };
  const handleClose = () => {
    setLoginmodel(false);
  };
  const handleClose2 = () => {
    setForgetModal(false);
  };

  return (
    <>
      <Header className={isFixed ? 'fixed' : ''}>
        <div className='header-top' style={{ display: isFixed ? 'none' : '' }}>
          <div className="container-fluid header-top">
            <div className="header-top-content">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={ind_flag} alt="Logo" style={{ width: '28px', marginRight: '10px' }} />
                <span>Government of India</span>
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <button onClick={() => window.location.href = '/#home'}
                  title="Skip to main content" style={{ marginRight: '5px', border: 'none', background: 'transparent', padding: 0 }}>Skip to Main Content</button>
                <span>|</span>
                {/* <GoogleTranslate /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="header">
            <button
              type="button"
              onClick={() => window.location.href = '/'} // acts like a link
              className="logo"
              aria-label="Go to homePage"
              style={{ cursor: 'pointer', userSelect: 'none', border: 'none', background: 'transparent', padding: 0 }}
            >
              {/* <i className="fas fa-bolt"></i> */}
              
              <img src={emblemLogo} className='logo-image' alt="Emblem of India" />
              <img src={cdac_logo} className='logo-image' alt="CDAC logo" />
              <img src={asaaua_logo} className='logo-image' alt="asa-aua logo" />
              {/* <a href="http://google.com">C-DAC ASA-AUA</a> <br/>
          <a href="http://google.com">Facilitating Aadhaar Based Service</a> */}
              {/* <div>
            <span style={{ fontSize: '24px', display: 'block', fontWeight: 'bold' }}>ASA-AUA</span>
            <span style={{ fontSize: '12px', display: 'block', textTransform: 'none' }}>Facilitating Aadhaar Based Service</span>
          </div> */}
            </button>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className="mobileHidden">
                {/* <Anchor targetOffset={65}> */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  {/* <Link href="#about" title="About Us" /> */}
                  <a
                    href="/"
                    className={active === "home" ? "active" : ""}
                  >
                    Home
                  </a>
                  {/* <a
                    href="/#about"
                    className={active === "about" ? "active" : ""}
                  >
                    Transaction Overview
                  </a> */}
                  <a
                    href="/#serviceoffered"
                    className={active === "serviceoffered" || active === "clients" ? "active" : ""}
                  >
                    Services Offered
                  </a>
                  <a
                    href="/registrationform"
                    className={active === "registrationform" ? "active" : ""}
                  >
                    Application/Enquiry Form
                  </a>
                  <a
                    href="/#faq" 
                    className={active === "faq" ? "active" : ""}
                  >
                    FAQ
                  </a>
                    


                  <div style={{ display: 'flex', gap: '10px', }}>
                    <Button className='login-btn' onClick={() => setLoginmodel(true)}>
                      Login
                      <ArrowRightOutlined className="login-icon"
                        style={{ transition: '0.8s !important' }}
                      />

                    </Button>
                    {/* <a href="http://10.210.12.233/" target="_blank" rel="noopener noreferrer"> */}
                   {/* <Button
                      type="text"
                      icon={<CustomerServiceOutlined />}
                      style={{
                        background: "white",
                        color: "#1515b4",
                        borderRadius: "24px",
                        padding: "0 16px",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                      onClick={() => window.open("http://10.210.12.233/", "_blank")}
                      onMouseEnter={(e) => {
                        (e.currentTarget as HTMLButtonElement).style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.4)";
                        (e.currentTarget as HTMLButtonElement).style.transition = "all 0.3s ease";
                        (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        (e.currentTarget as HTMLButtonElement).style.background = "white";
                        (e.currentTarget as HTMLButtonElement).style.color = "#1515b4";
                        (e.currentTarget as HTMLButtonElement).style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.4)";
                        (e.currentTarget as HTMLButtonElement).style.transition = "all 0.3s ease";
                        (e.currentTarget as HTMLButtonElement).style.transform = "translateY(0px)";
                      }}
                    >
                      Help Desk
                    </Button> */}
        
                  </div>
                </div>
                {/* <Button className='login-btn' onClick={() => setLoginmodel(true)}>
                  Login
                  <ArrowRightOutlined className="login-icon"
                    style={{ transition: '0.8s !important' }}
                  />

                </Button> */}
              </div>

            <div className="mobileVisible">

                      <Button
                        type="primary"
                        onClick={showDrawer}
                        style={{
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          border: 'none',
                          borderRadius: '24px',
                          padding: '6px 16px',
                          fontWeight: 600,
                          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                        }}
                      >
                        {/* <i className="fas fa-bars"></i> */}
                        <MenuOutlined />
                      </Button>
                      <Drawer
                        placement="right"
                        closable={true}
                        onClose={onClose}
                        open={visible}
                        style={{ padding: '0px !important' }}
                      >
                        {/* <Anchor targetOffset={65}> */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '0px' }}>
                          <Button
    onClick={() => {
        navigate("/");
        onClose();
    }}
    style={{
        border: "none",
        justifyContent: "flex-start",
        width: "100%",
        boxShadow: "none",
    }}
>
    Home
</Button>
<Button
    onClick={() => {
        navigate("/#serviceoffered");
        onClose();
    }}
    style={{
        border: "none",
        justifyContent: "flex-start",
        width: "100%",
        boxShadow: "none",
    }}
>
    Service Offered
</Button>
<Button
    onClick={() => {
        navigate("/registrationform");
        onClose();
    }}
    style={{
        border: "none",
        justifyContent: "flex-start",
        width: "100%",
        boxShadow: "none",
    }}
>
    Application/Enquiry Form
</Button>
<Button
    onClick={() => {
        handleFaqClick("faq");
        onClose();
    }}
    style={{
        border: "none",
        justifyContent: "flex-start",
        width: "100%",
        boxShadow: "none",
    }}
>
    FAQ
</Button>
                                                  <Button className='login-btn' onClick={() => { setLoginmodel(true); onClose(); }}>
                            Login
                            <ArrowRightOutlined className="login-icon"
                              style={{ transition: '0.8s !important' }}
                            />
                          </Button>
                          <Button className='login-btn' onClick={() => window.open("http://10.210.12.233/", "_blank")}>
                            <CustomerServiceOutlined className="login-icon"
                              style={{ transition: '0.8s !important' }}
                            />
                            Help Desk
                          </Button>
                        </div>
                        {/* </Anchor> */}
                      </Drawer>
                    </div>

            </div>
          </div>
        </div>
      </Header>
     <Modal
    open={loginModel}
    onCancel={handleClose}
    footer={null}
    centered
    destroyOnClose
    aria-labelledby="parent-modal-title"
    aria-describedby="parent-modal-description"
    styles={{
        body: {
            backgroundColor: "#ffffffff",
            borderRadius: "12px",
            padding: "12px"
        }
    }}
>
    <Loginpage
        setLoginmodel={setLoginmodel}
        setForgetModal={setForgetModal}
        setMessege={setMessege}
    />
</Modal>
      <Modal
        open={forgetModal}
        onCancel={handleClose2}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        footer={null}
        style={{ width: '85% !important', background: '#cce8ff', borderRadius: '8px' }}
        centered
      >
        <ForgetPassword setForgetModal={setForgetModal} />
      </Modal>
    </>

  );
}

export default AppHeader;